export var invalidFunction = function invalidFunction(message) {
  return function () {
    throw new Error(message);
  };
};